export const INITIAL_STATE_FOR_CREATE_PROJECT = {
	projectName: '',
	projectType: {},
	projectOwner: {},
	projectStartDate: '',
	projectEndDate: '',
	brand: {},
	buyer1stMeetingDate: '',
	season: '',
	styleCategoryDetails: '',
	fabricDetails: '',
	note: ''
};

export const PROJECT_TYPES = [
	{ value: 'General', id: 'GENERAL' },
	{ value: 'Pick and choose', id: 'PICK_AND_CHOOSE' },
	{ value: 'Buyer development', id: 'BUYER_DEVELOPMENT' },
	{ value: 'Buyer visit in UK', id: 'BUYER_VISIT_IN_UK' },
	{ value: 'Buyer visit in BD', id: 'BUYER_VISIT_IN_BD' },
	{ value: 'Onboarding new department', id: 'ONBOARDING_NEW_DEPARTMENT' },
	{ value: 'Opening new Core program', id: 'OPENING_NEW_CORE_PROGRAM' },
	{ value: 'Onboarding new customer', id: 'ONBOARDING_NEW_CUSTOMER' }
];

export const PROJECT_STATUS = [
	{ value: 'Pending', id: 'PENDING', name: 'Pending', constant: 'PENDING' },
	{ value: 'Running', id: 'RUNNING', name: 'Running', constant: 'RUNNING' },
	{ value: 'Completed', id: 'COMPLETED', name: 'Completed', constant: 'COMPLETED' }
];

// Status tag definitions
export const STATUS_TAGS = [
	{ id: 1, name: 'In Progress', color: 'blue' },
	{ id: 2, name: 'Pending', color: 'yellow' },
	{ id: 3, name: 'Not Started', color: 'gray' },
	{ id: 4, name: 'Completed', color: 'green' }
];

// Priority tag definitions
export const PRIORITY_TAGS = [
	{ id: 1, name: 'High', color: 'red' },
	{ id: 2, name: 'Medium', color: 'orange' },
	{ id: 3, name: 'Low', color: 'green' }
];

export const PROJECT_DETAILS_TABLE_COLUMNS = [
	{ id: 'TASK', name: 'Task', key: 'taskName' },
	{ id: 'COMMENTS', name: 'Comments', key: 'comments' },
	{ id: 'OWNER', name: 'Owner', key: 'owner' },
	{ id: 'START_DATE', name: 'Start Date', key: 'startDate', icon: '/icons/info.svg" ' },
	{ id: 'DUE_DATE', name: 'Due Date', key: 'dueDate', icon: '/icons/info.svg" ' },
	{ id: 'STATUS', name: 'Status', key: 'status', icon: '/icons/info.svg" ' },
	{ id: 'PRIORITY', name: 'Priority', key: 'priority' },
	{ id: 'REMARKS', name: 'Remarks', key: 'remarks' }
];

export const TASK_COLUMNS = {
	TASK: 'TASK',
	COMMENTS: 'COMMENTS',
	OWNER: 'OWNER',
	STATUS: 'STATUS',
	DUE_DATE: 'DUE_DATE',
	PRIORITY: 'PRIORITY',
	START_DATE: 'START_DATE',
	REMARKS: 'REMARKS'
};

export const COLOR_CODE_LIST = [
	'#1D4ED8', // Darker blue
	'#CC2121', // Dark red
	'#B7950B', // Dark yellow
	'#FC9403', // Dark blue
	'#7D3C98', // Dark purple
	'#03FC6B', // Dark green
	'#A04000', // Dark brown
	'#FFFF00', // Dark orange
	'#008080' // Dark violet
];

export const INITIAL_TASK_STATE = {
	name: '',
	taskStatusTagRequest: null,
	taskPriorityTagRequest: null,
	taskStatusTagResponse: null,
	taskPriorityTagResponse: null,
	ownerResponse: null,
	dueDate: '',
	startDate: '',
	remarks: '',
	taskGroupId: null,
	isNewTaskRow: false
};

export const TASK_SECTION_TABS = [
	{
		name: 'Table',
		id: 'TABLE_VIEW'
	},
	{
		name: 'Kanban',
		id: 'KANBAN_VIEW'
	},
	{
		name: 'Files',
		id: 'FILES_VIEW'
	}
];

export const MIX_PANEL_EVENTS = {
	PROJECT_LIST_ON_CLICK: 'PROJECT_LIST_ON_CLICK',
	PROJECT_DETAILS_VIEW: 'PROJECT_DETAILS_VIEW',
	PROJECT_ON_DRAG: 'PROJECT_ON_DRAG', //
	PROJECT_TASK_LIST_VIEW_CHANGE: 'PROJECT_TASK_LIST_VIEW_CHANGE',
	PROJECT_TASK_ON_DRAG: 'PROJECT_TASK_ON_DRAG',
	// PROJECT_TASK_EDIT: 'PROJECT_TASK_EDIT',
	PROJECT_TASK_COMMENT_PANEL_ON_CLICK: 'PROJECT_TASK_COMMENT_PANEL_ON_CLICK',
	PROJECT_TASK_LIST_FILTER: 'PROJECT_TASK_LIST_FILTER',
	PROJECT_TASK_COLUMN_VISIBILITY_ON_CHANGE: 'PROJECT_TASK_COLUMN_VISIBILITY_ON_CHANGE',
	PROJECT_ADD_LINK: 'PROJECT_ADD_LINK',
	ENTITY_LINK_ON_CLICK: 'ENTITY_LINK_ON_CLICK'
};

export const TAG_COLORS_LIST = [
	'#00C334',
	'#FCB400',
	'#F22B2B',
	'#C7CED4',
	'#3B82F6',
	'#FF08C2',
	'#06A09B',
	'#CE623E',
	'#21242B'
];
